import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators, AbstractControl, FormBuilder, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminServicesService } from '../../admin-services.service';
import { NgxSpinnerService } from "ngx-spinner";
import { concat } from 'rxjs';

@Component({
  selector: 'app-lead-bulk-uploads-admin',
  templateUrl: './lead-bulk-uploads-admin.component.html',
  styleUrls: ['./lead-bulk-uploads-admin.component.css']
})
export class LeadBulkUploadsAdminComponent implements OnInit {
  fileData: File;
  localStorageData: any;
  public uploadResponseData: any;
  form = this.fb.group({
    chooseFile: ['', Validators.compose([Validators.required, this.patternValidator()])],
  });

  public resData: any;
  datat = [];

  arrayData = [];
  str: string;
  file_name_restrict: any;
  file_name_restrict_new: any;
  get f() {
    return this.form.controls;
  }

  constructor(public toastr: ToastrService,
    private fb: FormBuilder,
    public router: Router,
    public admin: AdminServicesService,
    private SpinnerService: NgxSpinnerService) {
    
  }
  ngOnInit(): void {
    this.localStorageData = JSON.parse(localStorage.getItem('userDetails'));
  }

  patternValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = this.validateUserName(control.value);
      return valid ? null : { invalidFormat: true };
    };
  }

  validateUserName(userName: string) {
    return (userName.substring(userName.length - 3, userName.length) == "csv");
  }

  fileProgress(files: any) {

    let formData = new FormData();    
    formData.append('file',this.fileData);
    formData.append('user_id', this.localStorageData.userId);

    let temp_fileData = <File>files.target.files[0];
    this.fileData = <File>files.target.files[0];
    this.str = temp_fileData.name;
    this.file_name_restrict = this.str.split('(');
    this.file_name_restrict_new = this.file_name_restrict[1];
    if (this.file_name_restrict_new) {
      this.reset();
      return this.toastr.error("Please Rename Ur File");
    }
    if (temp_fileData.type === 'application/vnd.ms-excel') {
      this.fileData = <File>files.target.files[0];
    }
    else {
      this.reset();
      return this.toastr.error("Files Only");
    }


  }

  test(name: string) {
    for (let i = 0; i < this.resData[name].length; i++) {
      let element = this.resData[name][i];
      let a = '';
      let b = '';
      let c = '';
      let d = '';

      if (name == 'already_existing_leads') {
        a = 'aleName';
        b = 'aleEmail';
      } else if (name == 'already_citizen') {
        a = 'aelName';
        b = 'aelEmail';
      } else if (name == 'inserted_data') {
        a = 'instName';
        b = 'instEmail';
        d = 'yes'
      } else if (name == 'missing_data') {
        a = 'mdName';
        b = 'mdEmail';
        c = 'type';
      }

      if (this.datat[i] == undefined) {
        this.datat[i] = {};
      }
      if (element.Name == undefined) {
        this.datat[i][a] = "--";
      } else {
        this.datat[i][a] = element.Name;
        this.datat[i][d] = 1;
      }
      if (element.Email == undefined) {
        this.datat[i][b] = "--";
      } else {
        this.datat[i][b] = element.Email;
      }

      if (element['Missing Value']) {
        this.datat[i][c] = element['Missing Value']
      }
    }
  }

  submit() {
    let formData = new FormData();
    formData.append('file',this.fileData);
    formData.append('user_id', this.localStorageData.userId);
    this.SpinnerService.show();
    this.admin.bulkUpload(formData).subscribe((res: any) => {
      if (res.code === 200) {
        this.SpinnerService.hide();
        this.resData = res;
        this.test('already_existing_leads');
        this.test('missing_data');
        this.test('already_citizen');
        this.test('inserted_data');
        this.toastr.success("Uploaded Successfully");
        this.reset();
        this.form.controls.chooseFile.touched;
      } else if (res.code === 402) {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
        // this.fileData = null;
      } else if (res.code === 404) {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
        // this.fileData = null;
      } else if (res.code === 500) {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
        // this.fileData = null;
      }
      else {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
        // this.fileData = null;
      }
    },
      (err) => {
        this.SpinnerService.hide();
        // this.fileData = null;
        return this.toastr.error(err.message);
      });

  }

  insertedData(instName: any, instEmail: any) {
    let obj = {
      "email": instEmail,
      "user_name": instEmail,
      "invitedfrom": this.localStorageData.userName
    };
    this.admin.insertedClick(obj).subscribe((res: any) => {
      if (res.code == 200) {
        this.toastr.success(instEmail + ' ' + res.message);
        return;
      } else {
        this.toastr.error(res.message);
        return;
      }
    })
  }

  reset() {
    this.form.patchValue({ chooseFile: '' });
    this.fileData = <File>null;
  }
}
